import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { Expense } from '@webapp/modules/expense/entities/Expense'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'

type UseQueryExpenseReturn = {
  expense: Expense | undefined
  isLoading: boolean
  error: Error | null
}

export const useQueryExpense = (
  uuid: string
): UseQueryExpenseReturn => {
  const config = expenseReportQueryConfig.detail(uuid)

  const { data, isLoading, error } = useQuery({
    queryKey: config.queryKey,
    queryFn: config.queryFn,
  })

  const expense = useMemo(
    () => (data ? new Expense(data) : undefined),
    [data]
  )

  return {
    expense,
    isLoading,
    error: error as Error | null,
  }
}
